import React, { useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap'


const PrimarySubstance = () => {

    const [show, toggleShow] = useState(true);

    const [selectedOption, setSelectedOption] = useState(''); // Initialize with an empty string or 'yes'/'no'

    const handleOptionChange = (event) => {
      setSelectedOption(event.target.value);
    };

  return (
    <div>
      <Container>
        <Row>
            <Col md={12}>
            {show && <Card className=' shadow-sm px-2' border='0'>
                    <div className='d-flex justify-content-between align-items-center'>
                        <h6 className='text-secondary mt-3'>PrimarySubstance</h6>
                        <button onClick={() => toggleShow(!show)} className='text-secondary bg-white border-0'>x</button>
                    </div>
                                <label htmlFor="yesOption" className='text-secondary mb-2 ' style={{fontSize:'14px'}}>
                                <input
                                    type="radio"
                                    id="yesOption"
                                    value="yes"
                                    checked={selectedOption === 'yes'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                   Alcohol
                                   
                                </label>


                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption"
                                    value="no"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    Amphetamine
                                </label>

                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    Cocaine
                                </label>

                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    Hallucinogens 
                                </label>
                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                <input
                                type="radio"
                                id="noOption1"
                                value="other"
                                checked={selectedOption === 'no'}
                                onChange={handleOptionChange}
                                className='me-3'
                                />
                                Inhalants 
                            </label>
                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                    <input
                                    type="radio"
                                    id="noOption1"
                                    value="other"
                                    checked={selectedOption === 'no'}
                                    onChange={handleOptionChange}
                                    className='me-3'
                                    />
                                    Marijuana
                                </label>
                                <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                <input
                                type="radio"
                                id="noOption1"
                                value="other"
                                checked={selectedOption === 'no'}
                                onChange={handleOptionChange}
                                className='me-3'
                                />
                                Opiates
                            </label>
                            <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                <input
                                type="radio"
                                id="noOption1"
                                value="other"
                                checked={selectedOption === 'no'}
                                onChange={handleOptionChange}
                                className='me-3'
                                />
                                Sedatives
                            </label>
                            <label htmlFor="noOption"  className='text-secondary mb-2' style={{fontSize:'14px'}}>
                                
                                <input
                                type="radio"
                                id="noOption1"
                                value="other"
                                checked={selectedOption === 'no'}
                                onChange={handleOptionChange}
                                className='me-3'
                                />
                                Steroids
                            </label>
                            
                </Card>}
            </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PrimarySubstance
